import {
  primaryWhiteColor,
  primarySteperColor,
  regularFont,
  getRelativeFontSize,
} from "../../../../utils/styles";

const AddNewTeamStyles = {
  headerWrapper: {
    padding: "0 20px",
  },
  profileWrapper: {
    width: "100%",
  },

  stepperStyle: {
    marginLeft: 14,
    marginTop: 5,
    "& .MuiStepConnector-root": {
      marginLeft: 2.7,
      borderLeft: "3px solid #9E9FAB",
    },
  },

  // completed: {
  //   "& .css-mza7pb-MuiStepLabel-root .MuiStepIcon-root": {
  //     boxShadow: "0 0 0 5px red",
  //     borderRadius: "50%",
  //   },
  // },

  label: {
    ...regularFont,
    fontSize: getRelativeFontSize(-2),
    marginLeft: "10px",
    width: "70px",
    "&:hover": {
      cursor: "pointer !important",
    },
  },

  stepLabel: {
    "& 	.MuiStepIcon-root": {
      width: "35px",
      height: "35px",
      border: "5px solid",
      borderColor: primaryWhiteColor,
      boxShadow: `0 0 0 4px ${"#9E9FAB"}`,
      borderRadius: "50%",
      ...regularFont,
      "&:hover": {
        cursor: "pointer !important",
      },
    },

    "& .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed": {
      color: "#646DEA",
      boxShadow: "0 0 0 5px #646DEA",
    },

    "& .css-14pf2dw-MuiStepLabel-root .MuiStepIcon-root": {
      boxShadow: `0 0 0 5px ${primarySteperColor}`,
    },

    "& .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-active": {
      color: primarySteperColor,
      borderColor: primaryWhiteColor,
      boxShadow: `0 0 0 5px ${primarySteperColor}`,
    },
  },
};

export default AddNewTeamStyles;
